interface StaticImageOptions {
  userAgent: string;
  lat: number;
  lng: number;
  height: number;
  width: number;
  baseUrl?: string;
  fill?: string;
  marker?: 'pin-s' | 'pin-l-pharmacy';
  theme?: 'streets-v10' | 'light-v10' | 'outdoors-v11' | 'dark-v10' | 'satellite-v9' | 'satellite-streets-v11';
  zoom?: number;
  highRes?: boolean;
  hideMarker?: boolean;
}

export const getStaticMapImageSrc = ({
  userAgent,
  lat,
  lng,
  width,
  height,
  baseUrl = process.env.MAPBOX_API_BASE_URL,
  fill = '0066cc',
  marker = 'pin-l-pharmacy',
  theme = 'streets-v10',
  zoom = 14,
  highRes = false,
  hideMarker = false,
}: StaticImageOptions): string => {
  let defaultImageSrc = '';

  if (!userAgent || (userAgent && !userAgent.includes('AhrefsBot'))) {
    const queryParams = `access_token=${process.env.MAPBOX_API_KEY}&attribution=true&logo=false`;
    if (hideMarker) {
      defaultImageSrc = `${baseUrl}/${theme}/static/${lng},${lat},${zoom}/${width}x${height}${
        highRes ? '@2x' : ''
      }?${queryParams}`;
    } else {
      defaultImageSrc = `${baseUrl}/${theme}/static/${marker}+${fill}(${lng},${lat})/${lng},${lat},${zoom}/${width}x${height}${
        highRes ? '@2x' : ''
      }?${queryParams}`;
    }
  }

  return defaultImageSrc;
};
